module.exports = __webpack_public_path__ + "static/Privacy-f36e636300422462470083b2ea0b6040.svg";